<div class="modal-overlay" *ngIf="isModalOpen" (click)="close()">
  <div class="modal-content" (click)="$event.stopPropagation()">
    <div class="modal-header">
      <h2>SMRS Rate Management</h2>
      <button class="close-btn" (click)="close()">&times;</button>
    </div>
    
    <div class="modal-body">
      <!-- List of Rates -->
      <div class="period-selector">
        <div class="period-filters">
          <div class="filter-group">
            <label class="filter-label">Configure Rates For:</label>
            <select [(ngModel)]="selectedPeriod" (ngModelChange)="onPeriodChange()" class="filter-select">
              <option *ngFor="let p of periods" [value]="p">{{ p }}</option>
            </select>
          </div>
        </div>
        <div class="period-actions" *ngIf="selectedPeriod">
          <button (click)="copyFromPreviousPeriod()" class="copy-btn">
            Copy from Previous Month
          </button>
          <div class="copy-specific-wrapper">
            <button (click)="toggleCopySpecificMonth()" class="copy-btn copy-specific-btn">
              Copy from a Specific Month
            </button>
            <div *ngIf="isCopySpecificMonthOpen" class="copy-specific-dropdown">
              <label class="dropdown-label">Select Month:</label>
              <select [(ngModel)]="copySpecificPeriod" (ngModelChange)="onSelectSpecificPeriod($event)" class="copy-dropdown-select">
                <option value="" disabled selected>-- Select Month --</option>
                <option *ngFor="let p of availableCopyPeriods" [value]="p">{{ p }}</option>
              </select>
            </div>
          </div>
        </div>
      </div>

      <div class="rates-list">
        <table class="rates-table">
          <thead>
            <tr>
              <th class="col-handle"></th>
              <th>Name</th>
              <th>Rate (%)</th>
              <th>KCEG Rate (%)</th>
              <th class="keys-col" *ngIf="selectedBrandName === 'LFC'">Import Keys (서버비 구분)</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let rate of filteredRates; let i = index" 
                draggable="true" 
                (dragstart)="onDragStart($event, rate)" 
                (dragend)="onDragEnd($event)"
                (dragover)="onDragOver($event)" 
                (drop)="onDrop($event, rate)">
              <td class="handle-cell">
                <div class="drag-handle" title="Drag to reorder">
                  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><line x1="3" y1="12" x2="21" y2="12"></line><line x1="3" y1="6" x2="21" y2="6"></line><line x1="3" y1="18" x2="21" y2="18"></line></svg>
                </div>
              </td>
              <td>{{ rate.name }}</td>
              <td>{{ rate.rate }}%</td>
              <td>{{ rate.kcegRate }}%</td>
              <td class="keys-col" *ngIf="selectedBrandName === 'LFC'">
                <div class="keys-content" title="{{ rate.importKeys.join(', ') }}">{{ rate.importKeys.join(', ') }}</div>
              </td>
              <td>
                <button class="action-btn edit-btn" (click)="editRate(rate)">Edit</button>
                <button class="action-btn delete-btn" (click)="deleteRate(rate)">Delete</button>
              </td>
            </tr>
            <tr *ngIf="filteredRates.length === 0">
              <td [attr.colspan]="selectedBrandName === 'LFC' ? 6 : 5" class="text-center">No rates defined. Please add one.</td>
            </tr>
          </tbody>
        </table>
      </div>

      <!-- Add/Edit Form -->
      <div class="rate-form">
        <h3>{{ editingRate ? 'Edit Rate' : 'Add New Rate' }}</h3>
        <div class="form-grid">
          <div class="form-group">
            <label>Name</label>
            <input type="text" [(ngModel)]="formData.name" placeholder="e.g. Regular Frame">
          </div>
          <div class="form-group">
            <label>Rate (%)</label>
            <input type="number" [(ngModel)]="formData.rate" placeholder="e.g. 8">
          </div>
          <div class="form-group">
            <label>KCEG Rate (%)</label>
            <input type="number" [(ngModel)]="formData.kcegRate" placeholder="e.g. 5">
          </div>
          <div class="form-group" *ngIf="selectedBrandName === 'LFC'">
            <label>Import Keys</label>
            <div class="keys-grid-container">
              <table class="keys-table">
                <thead>
                  <tr>
                    <th></th>
                    <th>Key (Revenues)</th>
                    <th>IP</th>
                  </tr>
                </thead>
                <tbody>
                  <ng-container *ngFor="let group of displayKeys">
                    <tr class="group-row">
                      <td><input type="checkbox" [checked]="isGroupSelected(group)" [indeterminate]="isGroupPartiallySelected(group)" (change)="toggleGroup(group)"></td>
                      <td class="group-key-cell">
                        <button class="expand-btn" (click)="group.expanded = !group.expanded" *ngIf="group.ips.length > 0">
                          {{ group.expanded ? '▼' : '▶' }}
                        </button>
                        {{ group.key }}
                      </td>
                      <td></td>
                    </tr>
                    <ng-container *ngIf="group.expanded">
                      <tr *ngFor="let ip of group.ips" class="ip-row">
                        <td class="text-center"><input type="checkbox" [checked]="isIpSelected(group, ip)" (change)="toggleIp(group, ip)"></td>
                        <td></td>
                        <td class="ip-cell">{{ ip }}</td>
                      </tr>
                    </ng-container>
                  </ng-container>
                  <tr *ngIf="displayKeys.length === 0">
                    <td colspan="3" class="text-center empty-keys-cell">No keys found. Upload a file first.</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
        <div class="form-actions">
          <button *ngIf="editingRate" class="cancel-btn" (click)="cancelEdit()">Cancel</button>
          <button class="save-btn" (click)="saveRate()">{{ editingRate ? 'Apply Update' : 'Add to List' }}</button>
        </div>
      </div>

      <div class="modal-footer">
        <button class="cancel-btn" (click)="close()">Cancel</button>
        <button class="save-btn save-all-btn" (click)="saveAllChanges()">Save All Changes</button>
      </div>
    </div>
  </div>
</div>
